<template>
  <!-- <div class="body"> -->
    <!-- <div class="logo-wrapper">
      <img src="@/assets/kf-logo.svg" alt="Logo" class="logo" />
    </div> -->
    <!-- <div class="content-center"> -->
      <v-card class="card">
        <div class="d-flex justify-center align-center" style="height: 100%">
          <div class="text-center progress" v-if="value < 100">
            <v-progress-circular
              class="mt-7"
              :rotate="360"
              :size="75"
              :width="15"
              :model-value="value"
              color="#3C5AAA"
            >
            </v-progress-circular>
            <v-card-text v-if="!linkExpired" style="text-align: center"
              >Please wait while we verify your account.
            </v-card-text>
            <v-card-text
              v-if="linkExpired"
              style="text-align: center; color: red"
              >Please Contact Your Administrator,your link is Expired.
            </v-card-text>
          </div>
          <div
            v-else
            class="checkbox Verified d-flex justify-center flex-column"
          >
            <v-icon class="icon" size="75">mdi-check-circle</v-icon>
            <v-card-title class="pt-0 textM">Account Verified</v-card-title>
            <v-card-text class="pt-7" style="text-align: center"
              >Your account has been successfully verified</v-card-text
            >
          </div>
        </div>
      </v-card>
    <!-- </div> -->
  <!-- </div> -->
</template>

<script>
import UserService from "@/api/service/UserService";
export default {
  data() {
    return {
      linkExpired: false,
      interval: {},
      value: 25,
      router: null,
    };
  },
  async mounted() {
    let data = this.$route.query.authorize;
    // this.value = 50;
    setTimeout(() => {
      this.value = 50;
    }, 3000);
    await UserService.getVerifyAccount({ authorize: data }).then(res => {
      console.log(res,"verifyafterddss")
        const appId = process.env.VUE_APP_APP_ID
       const $path = process.env.VUE_APP_APP_URL+'/login'
       const loginUrl = process.env.VUE_APP_API_IDENTITY_URL+'/'
      setTimeout(() => {
        this.value = 75;
      }, 3000);
      if (res?.data?.message == 'success') {
        this.value = 100
        setTimeout(() => {
          window.location = `${loginUrl}resetpassword?uid=${res?.data?.uid}&redirectUrl=${$path}&appId=${appId}`
        }, 3500)
      }
      else {
        this.linkExpired = true
      }
    })
  },
  methods: {},
};
</script>

<style scoped>
.card {
  width: 320px;
  background-color: #fff;
  border-radius: 12px !important;
  padding: 16px !important;
  border: none;
  box-shadow: none;
  height: 400px;
}

.card2 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.textM {
  text-align: center;
  position: relative;
  top: 35px;
}

.icon {
  position: relative;
  top: 20px;
  left: 40%;
}

>>> .v-progress-circular {
  margin-left: 1rem;
}

.progress {
  /* display: flex; */
  justify-content: center;
  align-items: center;
  width: 350px;
  height: 200px;
}

.Verified {
  width: 350px;
  height: 200px;
  color:#3C5AAA;
}

/* .body {
  background-image: url("../../assets/main.svg");
  width: 100%;
  height: 100vh;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
} */

/* .body::before {
  content: "";
  position: absolute;
  inset: 0;

}

.body > * {
  position: relative;
  z-index: 1;
} */

/* .logo-wrapper {
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
} */

/* .logo {
  max-height: 40px;
  width: auto;
} */



@media (max-width: 768px) {
  /* .logo-wrapper {
    top: 10px;
    left: 10px;
    padding: 4px 8px;
  }

  .logo {
    max-height: 30px;
  } */

  .content-center {
    padding: 0.5rem;
  }
}
</style>
 